export default __webpack_public_path__ + "31cb311160dd359711dfb618a5a15e3c.png";